document.addEventListener("alpine:init", () => {
	Alpine.data("searchableFacets", (facets, value) => ({
		facets: facets,
		q: "",
		get searchedFacets() {
			if (this.q.length === 0) return this.facets;
			return this.facets.filter((facet) => {
				return facet[value]
					.toLowerCase()
					.includes(this.q.toLowerCase());
			});
		},
	}));
	Alpine.bind("facet", () => ({
		"@click.prevent"() {
			this.$el.ariaDisabled = true;
			window.axios
				.get(this.$el.href)
				.then((response) => {
					if (response.data.error) {
						Toast.danger(response.data.error_message);
						return;
					}
					if (response.status === 200) {
						this.$el.ariaDisabled = false;
						if (document.getElementById("sorting")) {
							document.getElementById("sorting").innerHTML =
								response.data.data.sorting;
						}
						if (document.getElementById("facets")) {
							document.getElementById("facets").innerHTML =
								response.data.data.facets;
						}
						if (document.getElementById("facet-tags")) {
							document.getElementById("facet-tags").innerHTML =
								response.data.data.tags;
						}
						if (document.getElementById("products")) {
							document.getElementById("products").innerHTML =
								response.data.data.products;
						}
						if (document.getElementById("stores")) {
							document.getElementById("stores").innerHTML =
								response.data.data.stores;
							window.dispatchEvent(
								new CustomEvent("set-followables")
							);
						}

						history.replaceState({}, "", this.$el.href);
						window.dispatchEvent(
							new CustomEvent("set-favoritables")
						);
					}
				})
				.catch((error) => {
					console.log(error);
					Toast.danger("Υπήρξε ένα σφάλμα! Δοκίμασε ξανά.");
				});
		},
	}));
	Alpine.data("slider", () => ({
		minInput: null,
		maxInput: null,
		priceRangeUrl: null,
		initialMinValue: null,
		initialMaxValue: null,
		init() {
			this.minInput = document.getElementById("min-price-value");
			this.maxInput = document.getElementById("max-price-value");
			this.priceRangeUrl = document.getElementById("price-range-url");
			this.initialMinValue = this.$refs.slider.dataset.min;
			this.initialMaxValue = this.$refs.slider.dataset.max;
			let initialParams = new URLSearchParams(window.location.search);

			if (initialParams.has("price_min")) {
				this.initialMinValue = initialParams.get("price_min");
			}
			if (initialParams.has("price_max")) {
				this.initialMaxValue = initialParams.get("price_max");
			}

			const sliderData = {
				start: [this.initialMinValue, this.initialMaxValue],
				connect: true,
				margin: 1,
				range: {
					min: Math.floor(parseFloat(this.$refs.slider.dataset.min)),
					max: Math.ceil(parseFloat(this.$refs.slider.dataset.max)),
				},
				tooltips: [
					{
						to: function (value) {
							return Math.ceil(parseFloat(value)) + " €";
						},
						from: function (value) {
							return Math.floor(
								parseFloat(value.replace(" €", ""))
							);
						},
					},
					{
						to: function (value) {
							return Math.ceil(parseFloat(value)) + " €";
						},
						from: function (value) {
							return Math.floor(
								parseFloat(value.replace(" €", ""))
							);
						},
					},
				],
				cssPrefix: "find-slider-",
				step: 1,
			};

			import("nouislider")
				.then((module) => {
					const noUiSlider = module.default;

					noUiSlider.create(this.$refs.slider, sliderData);
					this.$refs.slider.noUiSlider.on("update", (values) => {
						let minValue = parseInt(values[0].replace(" €", ""));
						let maxValue = Math.ceil(
							parseFloat(values[1].replace(" €", ""))
						);
						this.minInput = minValue + " €";
						this.maxInput = maxValue + " €";
						const url = new URL(window.location.href);
						const params = new URLSearchParams(url.search);
						params.delete("page");
						params.set("price_min", minValue);
						params.set("price_max", maxValue);
						url.search = "?" + params.toString();
						this.priceRangeUrl.href = url.href;
					});
				})
				.catch((error) => {
					console.error("Error loading noUiSlider:", error);
				});
		},
	}));
});
